import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enAntd from 'antd/lib/locale/en_GB';
import frAntd from 'antd/lib/locale/fr_FR';
import esAntd from 'antd/lib/locale/es_ES';
import ptAntd from 'antd/lib/locale/pt_PT';
import gerAntd from 'antd/lib/locale/de_DE';

import { LanguageEnum } from '@/constants/enums';

import fake from './fake.js';
import en from './languages/en.js';
import fr from './languages/fr.js';
import es from './languages/es.js';
import pt from './languages/pt.js';
import de from './languages/de.js';

// the translations
const resources = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
  es: {
    translation: es,
  },
  pt: {
    translation: pt,
  },
  de: {
    translation: de,
  },
  fake: {
    translation: fake,
  },
};

export const browserLanguage = navigator.language.split(/[-_]/)[0];
const savedLanguage = localStorage.getItem('language');
export const AntdLanguageMapping = {
  [LanguageEnum.EN]: enAntd,
  [LanguageEnum.FR]: frAntd,
  [LanguageEnum.ES]: esAntd,
  [LanguageEnum.PT]: ptAntd,
  [LanguageEnum.DE]: gerAntd,
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: savedLanguage || browserLanguage || LanguageEnum.EN,

    fallbackLng: {
      default: [savedLanguage || browserLanguage || LanguageEnum.EN],
    },

    keySeparator: false, // we do not use keys in form messages.welcome
    nsSeparator: false,

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      bindI18n: 'loaded languageChanged',
      bindI18nStore: 'added',
      useSuspense: true,
    },
  });

export default i18n;
